__turbopack_context__.v({
  "body": "WDefault-module__jKaEVa__body",
  "root": "WDefault-module__jKaEVa__root",
  "title": "WDefault-module__jKaEVa__title",
});
